import { render } from "./PetitionIndexDetails.vue?vue&type=template&id=b7fa72a4"
import script from "./PetitionIndexDetails.vue?vue&type=script&lang=js"
export * from "./PetitionIndexDetails.vue?vue&type=script&lang=js"

import "./PetitionIndexDetails.vue?vue&type=style&index=0&id=b7fa72a4&lang=css"

import exportComponent from "E:\\wamp64\\www\\law-firm-system-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__